// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","content":"Card_content__3+f8H"};